import { UnstyledButton } from '@mantine/core';
// icons
import { Trash2, Edit, Copy } from 'lucide-react';
// utils
import type { ITopic } from '@newo/api/gateway';

interface ActionsProps {
    topic: ITopic;
    onCopy: (topic: ITopic) => void;
    onDelete: (topicId: string) => void;
    onEdit: (topic: ITopic) => void;
}

const Actions = ({ topic, onCopy, onDelete, onEdit }: ActionsProps) => {
    const handleDelete = () => {
        onDelete(topic.topic_id);
    };
    const handleEdit = () => {
        onEdit(topic);
    };

    const handleCopy = () => {
        onCopy(topic);
    };
    return (
        <div className="flex gap-4">
            <UnstyledButton onClick={handleDelete}>
                <Trash2 />
            </UnstyledButton>
            <UnstyledButton onClick={handleCopy}>
                <Copy />
            </UnstyledButton>
            <UnstyledButton onClick={handleEdit}>
                <Edit />
            </UnstyledButton>
        </div>
    );
};

export default Actions;
